import { Component, Input, OnInit } from "@angular/core";
import { oldOrderTimesInDayOrder, orderTimeLabels, orderTimesInDayOrder, otherDeliveryTime } from "./order-time.enum";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { SingleSelectFormFieldComponent } from "../select-form-field/single-select-form-field/single-select-form-field.component";
import { capitalizeFirstLetter } from "../../../../../services/utils/string.utils";

@Component({
  selector: "rc-order-time-form-field",
  templateUrl: "../select-form-field/base-select-form-field.component.html",
  styleUrls: ["./order-time-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: OrderTimeFormFieldComponent,
    },
  ],
  standalone: false,
})
export class OrderTimeFormFieldComponent extends SingleSelectFormFieldComponent implements OnInit {
  @Input() public useOldOrderTime: boolean = false;

  public ngOnInit() {
    super.ngOnInit();
    this.placeholder = "Pick a time";
    this.possibleValues = this.useOldOrderTime ? oldOrderTimesInDayOrder : [...orderTimesInDayOrder, otherDeliveryTime];
    this.possibleValuesLabels = this.useOldOrderTime
      ? oldOrderTimesInDayOrder
      : [...orderTimesInDayOrder.map((time) => orderTimeLabels[time]), capitalizeFirstLetter(otherDeliveryTime)];
    this.icon = "time-outline";
  }
}
